/**
 * # @ally/use-media-size
 *
 * > A custom hook that returns a boolean when given a media size type.
 *
 * ## Usage
 *
 * Pass a media type, and it will return a boolean.
 *
 * ```tsx
 * // use the hook
 * const isSmDown = useMediaSize('SmDown')
 *
 * // conditional styling
 * const headingMarginSize = isSmDown ? undefined : 0
 *
 * // style a component
 * <SectionHeading margin={headingMarginSize} />
 * ```
 */
import { useMediaQuery } from 'react-responsive';
import { muiBankTheme } from '../../theme';
const useMediaSize = (size) => {
    const query = muiBankTheme.mediaSizes[size];
    return useMediaQuery(query);
};
export default useMediaSize;
//# sourceMappingURL=useMediaSize.js.map